// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QHx_","label":"styles_label__y_xed"};